import React from 'react';
import {Result,Button} from 'antd';
import { useTranslation } from 'react-i18next';

function NotFoundPage(props){
	const {t} = useTranslation();
	return (
		<>
			<Result
				status="404"
				title="404"
				subTitle={t("Sorry, This page does not exist.")}
				extra={
					<Button type="primary">
						<a href="/ade-platform/web/public">{t("Back Home")}</a>
					</Button>
				}
  		/>
		</>
	);
}

export default NotFoundPage;
